import { Link, NavLink } from 'react-router-dom';
import { STATS } from '@/lib/databank';

const MarkGlyph = () => (
    <svg viewBox="0 0 40 40" fill="none" className="h-9 w-9 shrink-0" aria-hidden="true">
        <path d="M20 36C20 36 8 30 8 17C8 9 13 4 20 4C27 4 32 9 32 17C32 30 20 36 20 36Z" stroke="#2B3A2C" strokeWidth="1.3" />
        <path d="M20 4V36" stroke="#2B3A2C" strokeWidth="1" />
        <path d="M20 10C20 10 15 13 14 18" stroke="#2B3A2C" strokeWidth="0.8" />
        <path d="M20 16C20 16 26 19 27 24" stroke="#2B3A2C" strokeWidth="0.8" />
        <path d="M20 22C20 22 14 25 13 29" stroke="#2B3A2C" strokeWidth="0.8" />
    </svg>
);

export const Header = () => (
    <header data-testid="site-header" className="sticky top-0 z-50 border-b border-line bg-paper/80 backdrop-blur-md">
        <div className="mx-auto flex max-w-[1500px] items-center justify-between gap-6 px-5 py-3 md:px-10">
            <Link to="/" data-testid="header-brand-link" className="group flex items-center gap-3">
                <MarkGlyph />
                <span className="leading-tight">
                    <span className="block font-mono text-[10px] uppercase tracking-[0.28em] text-mute">Data Bank</span>
                    <span className="block font-serif text-lg italic text-ink md:text-xl">Asteraceae of Western Vidarbha</span>
                </span>
            </Link>
            <nav className="flex items-center gap-6 font-mono text-[11px] uppercase tracking-[0.22em]">
                <NavLink to="/" end data-testid="nav-index-link" className="u-line hidden sm:inline">Index</NavLink>
                <NavLink to="/gallery" data-testid="nav-collection-link" className="u-line">Collection</NavLink>
                <span className="hidden border border-line px-3 py-1.5 text-mute md:inline" data-testid="header-record-count">
                    {STATS.species} records
                </span>
            </nav>
        </div>
    </header>
);
